import chatelImg from '../assets/pictures/CHATEL-82.jpg';
import dolomitesImg from '../assets/pictures/DOLOMITES-125.jpg';
import martinswandImg from '../assets/pictures/MARTINSWAND-65.jpg';

export const projects = [
    {
        id: 1,
        title: "Chatel",
        category: "Mountains / 2024",
        coverImage: chatelImg,
        description: "A visual exploration of the alpine atmosphere in Chatel. Capturing the raw textures and silence of the high altitude environment."
    },
    {
        id: 2,
        title: "Dolomites",
        category: "Landscape / 2023",
        coverImage: dolomitesImg,
        description: "Journey through the dramatic peaks of the Dolomites. The play of light and shadow on the jagged rock formations creates a surreal landscape."
    },
    {
        id: 3,
        title: "Martinswand",
        category: "Climbing / 2024",
        coverImage: martinswandImg,
        description: "Vertical perspectives from the Martinswand. Documenting the connection between the climber and the imposing stone wall."
    }
];
